import type {ContactPhoneItem} from "@/shared/ui/data-display/phone-number/phone-number";

/**
 * Normalize number for tel: link (digits and + only).
 */
export function telHref(number: string): string {
    return `tel:${number.replace(/[^\d+]/g, "")}`;
}

/**
 * Parse contact.phone string into array of { label, number }.
 * Expected format: "Mexico: +52 984-803-3908 / International: 602-688-7378 / Toll-Free Number: 1-800-588-8681"
 */
export function parseContactPhones(phoneString: string | undefined): Array<ContactPhoneItem> {
    if (!phoneString?.trim()) return [];

    return phoneString
        .split(/\s*\/\s*/)
        .map((part) => {
            const colonIndex = part.indexOf(":");
            if (colonIndex === -1) {
                return {label: "", number: part.trim()};
            }
            return {
                label: part.slice(0, colonIndex).trim(),
                number: part.slice(colonIndex + 1).trim(),
            };
        })
        .filter((item) => item.number.length > 0);
}
